module.exports = __webpack_public_path__ + "img/index_part2img5.3ad96fc7.jpg";